import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Layout } from 'antd'
import clsx from 'clsx'
import Sticky from 'react-stickynode'

import { useCheckLocation } from '@/hooks'
import useDeviceDetect from '@/hooks/useDeviceDetect'
import { STICKY_Z_INDEX } from '@/libs/constants/header'

import SidebarMenu from '../SidebarMenu'

const { Sider } = Layout

const Sidebar = () => {
  const { t } = useTranslation()
  const { isInMyWorkspace } = useCheckLocation()
  const { isXLScreen } = useDeviceDetect()

  const classes = clsx(
    'sidebar__wrapper',
    isInMyWorkspace && 'sidebar__wrapper-homepage',
  )

  const renderSidebarHeader = (words) =>
    words.split(' ').map((word, index) => (
      <span key={`${word}${index + 1}`} style={{ whiteSpace: 'nowrap' }}>
        {word}
      </span>
    ))

  const renderSideBarMenu = () => (
    <Sider style={{ backgroundColor: 'transparent' }}>
      <div className="sidebar__header">
        {renderSidebarHeader(t('myBusinessWorkspace'))}
      </div>
      <SidebarMenu />
    </Sider>
  )
  const stickyTop = isInMyWorkspace ? 94 : 136

  return isXLScreen
    ? (
      <Sticky
        className={classes}
        innerZ={STICKY_Z_INDEX.SIDE_BAR}
        top={stickyTop}
      >
        <div className="sidebar__icons-wrapper">{renderSideBarMenu()}</div>
      </Sticky>
    )
    : null
}

export default Sidebar
